const  play_base_url = process.env.play_base_url
export const  enterpriseTelecelPlayChildren = [
    {
      label: "Account Management",
      icon: "register",
      url: "#",
      children: [
        {
          label: "Dashboard",
          url: `${play_base_url}/enterprise/`,
          children: [],
        },
        {
          label: "Account Details/Subscriptions",
          url: `${play_base_url}/account-details/`,
          children: [],
        },
        {
          label: "Make Payments",
          url: `${play_base_url}/pay/`,
          children: [],
        },
      ],
    },
    {
      label: "Requests",
      url: "#",
      icon: "roaming-system",
      children: [
        {
          label: "Call Detail Records",
          url: `${play_base_url}/cdr-request/`,
          children: [],
        },
        // {
        //   label: "PUK Requests",
        //   url: "#",
        //   children: [],
        // },
      ],
    },
    {
      label: "Support",
      url: "#",
      icon: "roaming-system",
      children: [
        {
          label: "Report a fault",
          url: `${play_base_url}/faults/reporting/`,
          children: [],
        },
        {
          label: "Track fault",
          url: `${play_base_url}/faults/tracking/`,
          children: [],
        },
        // {
        //   label: "FAQs",
        //   url: "#",
        //   children: [],
        // },
      ],
    },
  ]